import clsx from 'clsx';

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  title?: string;
  content?: string;
  useAsOverlay?: boolean;
}

export default function Loader({ size = 'md', title, content, useAsOverlay = false }: LoaderProps) {
  const containerStyles = clsx({
    'odin-absolute odin-flex odin-z-[1000] odin-h-full odin-w-full odin-bg-mono-1': useAsOverlay,
    'odin-inline-flex odin-flex-col': !useAsOverlay,
  });

  const styles = clsx('odin-rounded-full odin-bg-primary-2', {
    'odin-h-4 odin-w-4 odin-mt-1': size === 'sm',
    'odin-h-6 odin-w-6': size === 'md',
    'odin-h-8 odin-w-8 odin-mt-2': size === 'lg',
    'odin-h-12 odin-w-12 odin-mt-2': size === 'xl',
  });
  const titleSize = clsx('', {
    'odin-text-base odin-mb-1 odin-font-medium': size === 'sm',
    'odin-text-lg odin-mb-2 odin-font-medium': size === 'md',
    'odin-text-2xl odin-mb-2 odin-font-semibold': size === 'lg',
    'odin-text-4xl odin-mb-4 odin-font-semibold': size === 'xl',
  });
  const contentSize = clsx('odin-text-base odin-mb-2', {
    'odin-mb-3': size === 'sm',
    'odin-mb-5': size === 'md',
    'odin-mb-4': size === 'lg',
    'odin-text-lg odin-mb-4': size === 'xl',
  });
  return (
    <div className={containerStyles}>
      {title && <h1 className={`odin-text-center odin-text-primary-2 ${titleSize}`}>{title}</h1>}
      {content && <p className={`odin-text-center ${contentSize}`}>{content}</p>}
      <div className="odin-flex odin-w-full odin-items-center odin-justify-center odin-space-x-1 ">
        <span className={`odin-animate-pulse ${styles}`} />
        <span className={`odin-animate-pulse-delay-short ${styles}`} />
        <span className={`odin-animate-pulse-delay-long ${styles}`} />
      </div>
    </div>
  );
}
